<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                <h4 class="modal-title">{{ $t('tasks_list') }}</h4>
            </div>
            <div class="p-15 p-b-0">
                <h4 class="header-title m-b-20 t_center">{{ $t('consultant') }}: <span class="f_normal">{{ memberFullName }}</span></h4>
                <div class="row">
                    <div class="col-xs-12 col-sm-6 m-b-15 clearfix" v-if="!fakeStatus">
                        <label>{{ $t('status') }}</label>
                        <pml-multiselect v-model="filters.status_s" :options="status"></pml-multiselect>
                    </div>
                    <div class="col-xs-12 col-sm-6 m-b-15 clearfix" v-if="fakeStatus">
                        <label>{{ $t('status') }}</label>
                        <pml-select v-model="extraFilter" :options="extraOptions" :allow-empty="false"></pml-select>
                    </div>
                    <div class="col-xs-12 col-sm-6 m-b-15 clearfix">
                        <label>{{ $t('access_ways') }}</label>
                        <pml-select v-model="filters.access_way_id" :options="accessWays"></pml-select>
                    </div>
                </div>
            </div>
            <div class="over_auto p-t-15" style="min-height: 88px" v-pml-block="isLoading">
                <table class="table table-striped table-bordered m-0 table_hover_link">
                    <thead>
                        <tr>
                            <th class="t_center w_80 th_sort" @click.prevent="setOrder('due_date_at')" :class="isOrderedColumn('due_date_at')">{{ $t('date') }}</th>
                            <th class="th_sort" colspan="2" @click.prevent="setOrder('full_name')" :class="isOrderedColumn('full_name')">{{ $t('lead') }}</th>
                            <th class="th_sort" @click.prevent="setOrder('title')" :class="isOrderedColumn('title')">{{ $t('task') }}</th>
                            <th class="t_center th_sort" @click.prevent="setOrder('status')" :class="isOrderedColumn('status')">{{ $t('status') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="task in showing" :key="task.id" @click.prevent="openTask(task)">
                            <td class="t_center">{{ task.due_date_at | pmlDate('DD/MM/YYYY HH:mm') }}</td>
                            <td class="b_r_none w_40">
                                <img class="img-circle thumb-sm" :src="task.deal.lead.avatar || '/static/images/avatar.jpg'" :title="task.deal.lead.full_name">
                            </td>
                            <td class="p-l-0">
                                <p class="c_default bold m-0">{{ '#' + task.deal.code + ' - ' + task.deal.lead.full_name}}</p>
                                <small class="text-muted" v-if="task.deal.lead.reference">({{ task.deal.lead.reference }})</small>
                                <small class="show t_overflow">{{ task.deal.lead.email }}</small>
                            </td>
                            <td>
                                <span class="show">{{ task.title }}</span>
                                <span class="label label-info" :style="'background-color: ' + $options.filters.pmlAccessWayById(task.access_way_id, 'color') + ';'">{{task.access_way_id | pmlAccessWayById('name')}}</span>
                            </td>
                            <td class="t_center">
                                <span v-if="task.status === 'pending'" :class="`label label-${isAfter(task.due_date_at) ? 'danger' : 'warning'}`">{{ $t(isAfter(task.due_date_at) ? 'overdue' : 'pending') }}</span>
                                <span v-else :class="`label label-${getColor(task.status)}`">{{ $t(task.status) }}</span>
                            </td>
                        </tr>
                        <tr v-if="list.length === 0 && !isLoading">
                            <td class="t_center" colspan="6"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import { getTasksReport } from '@/services/reports'
    import { mapGetters } from 'vuex'
    import RoutedModals from '@/utils/mixins/routed-modals'
    import TableFilters from '@/utils/mixins/table-filters'
    import moment from 'moment'
    import { utcToLocal } from '@/utils/helpers/dates.js'
    import { trans } from '@/utils/helpers/translation'
    import { map } from 'lodash'

    export default {
        name: 'show',
        mixins: [ RoutedModals, TableFilters ],
        data () {
            return {
                goBackTo: '/reports/tasks',
                isLoading: true,
                memberFullName: null,
                extraFilter: null,
                extraOptions: [
                    {id: 'all', name: trans('all')},
                    {id: 'overdue', name: trans('overdue')},
                    {id: 'pending', name: trans('pending')}
                ],
                records: [],
                filters: {
                    due_date_at_from: null,
                    due_date_at_to: null,
                    member_id: null,
                    status_s: [],
                    access_way_id: null
                },
                listConfig: {
                    filter: '',
                    orderProp: 'due_date_at',
                    orderDir: 'desc',
                    columns: ['due_date_at', 'full_name', 'title', 'status']
                }
            }
        },
        mounted () {
            this.initFilters()
        },
        beforeDestroy () {
            window.localStorage.removeItem('pml_reports_tasks_show')
        },
        computed: {
            ...mapGetters({
                'accessWays': 'getAccessWays',
                'status': 'getTaskStatus',
                'member': 'getMember'
            }),
            showing () {
                if (this.isLoading)
                    return []
                else if (typeof this.extraFilter !== 'string' || this.extraFilter === 'all')
                    return this.list

                let showing = []

                for (let task of this.list)
                    if (this.isAfter(task.due_date_at) && this.extraFilter === 'overdue')
                        showing.push(task)
                    else if (!this.isAfter(task.due_date_at) && this.extraFilter === 'pending')
                        showing.push(task)

                return showing
            },
            fakeStatus () {
                return typeof this.extraFilter === 'string'
            }
        },
        watch: {
            'filters.access_way_id' () {
                setTimeout(() => { this.getList() }, 200)
            },
            'filters.status_s.length' () {
                setTimeout(() => { this.getList() }, 200)
            }
        },
        methods: {
            initFilters () {
                if (typeof this.$route.params.member_id !== 'undefined') {
                    this.filters.member_id = this.$route.params.member_id
                    this.memberFullName = this.$options.filters.pmlMemberById(this.filters.member_id, 'full_name')
                } else {
                    this.filters.member_id = this.member.id
                    this.memberFullName = this.member.full_name

                    let extraFilter = this.validateStore(window.localStorage.getItem('pml_reports_tasks_show'))
                    this.extraFilter = (typeof extraFilter !== 'string') ? 'all' : extraFilter
                }

                let statusS = this.validateStore(window.localStorage.getItem('pml_reports_tasks_status_s'))
                this.filters.status_s = (typeof statusS !== 'string') ? [] : statusS.split(',')
                this.filters.access_way_id = this.validateStore(window.localStorage.getItem('pml_reports_tasks_access_way_id'))
                this.filters.due_date_at_from = this.validateStore(window.localStorage.getItem('pml_reports_tasks_due_date_at_from'))
                this.filters.due_date_at_to = this.validateStore(window.localStorage.getItem('pml_reports_tasks_due_date_at_to'))

                this.getList()
            },
            validateStore (value) {
                if (typeof value !== 'string')
                    return null
                else if (value === 'null' || value === 'undefined' || value === '')
                    return null
                else
                    return value
            },
            getList () {
                this.isLoading = true
                getTasksReport({...this.filters, report_type: 'consultant_table'})
                    .then((response) => {
                        this.records = map(response.data, (item) => {
                            item['full_name'] = item.deal.lead.full_name
                            return item
                        })
                    })
                    .catch((e) => { console.log(e) })
                    .then(() => { this.isLoading = false })
            },
            isAfter (dueDate) {
                return (moment().isAfter(utcToLocal(dueDate)))
            },
            getColor (status) {
                if (status === 'done') return 'default'
                if (status === 'pending') return 'warning'
                if (status === 'canceled') return 'light'
            },
            openTask (task) {
                window.open(`/deals/${task.deal_id}/tasks/${task.id}/edit`)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/tasks/components/Show.vue